import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m18.756 20-5.6-5.6a5.416 5.416 0 0 1-3.378 1.156c-1.615 0-2.982-.56-4.1-1.678C4.559 12.759 4 11.393 4 9.778c0-1.615.56-2.982 1.678-4.1C6.796 4.559 8.163 4 9.778 4c1.615 0 2.981.56 4.1 1.678 1.118 1.118 1.678 2.485 1.678 4.1a5.416 5.416 0 0 1-1.156 3.378l5.6 5.6L18.756 20Zm-8.978-6.222c1.11 0 2.055-.39 2.833-1.167.778-.778 1.167-1.722 1.167-2.833 0-1.111-.39-2.056-1.167-2.834-.778-.777-1.722-1.166-2.833-1.166-1.111 0-2.056.389-2.834 1.166-.777.778-1.166 1.723-1.166 2.834 0 1.11.389 2.055 1.166 2.833.778.778 1.723 1.167 2.834 1.167Z" }, null, -1)
  ])))
}
export default { render: render }